module.exports = __webpack_public_path__ + "img/heartbeat.63c8922.svg";